import type React from 'react';

import { XingletLoader as ScrollToTop } from '@xing-com/crate-xinglet';
import { GridItem } from '@xing-com/grid';
import { Section } from '@xing-com/layout-primitives';

import { AccordionSection } from './accordion-section';
import { ArticlesBoxSection } from './articles-box-section';
import { Container } from './bewerbung-topic-page.styles';
import { CoverLetterSection } from './cover-letter-section';
import { FooterSection } from './footer-section';
import { HeadingSection } from './heading-section';
import { InsightsSection } from './insights-section';
import { InspirationalCardsSection } from './inspirational-cards-section';
import { IntroductoryTextSection } from './introductory-text-section';
import { LebenslaufSection } from './lebenslauf-section';
import { VideoSection } from './video-section';

export const BewerbungTopicPage: React.FC = () => {
  return (
    <Section noBlockPadding>
      <Container variant="FullSize">
        <GridItem span={12}>
          <HeadingSection />
        </GridItem>
        <GridItem span={12} spanLarge={10} startLarge={2}>
          <IntroductoryTextSection />
          <ArticlesBoxSection />
          <CoverLetterSection />
          <LebenslaufSection />
          <AccordionSection />
          <VideoSection />
          <InsightsSection />
          <InspirationalCardsSection />
          <ScrollToTop name="@xing-com/crate-layout-scroll-to-top" />
          <FooterSection />
        </GridItem>
      </Container>
    </Section>
  );
};
